import apiClient from './apiClient';
import { cleanParams } from '@/utils/buildQuery';

const base = '/admin/news';

export const newsService = {
  list: (params) => apiClient.get(base, { params: cleanParams(params) }),
  get: (id) => apiClient.get(`${base}/${id}`),
  create: (payload) => apiClient.post(base, payload),
  update: (id, payload) => apiClient.put(`${base}/${id}`, payload),
  setStatus: (id, isActive) => apiClient.patch(`${base}/${id}/status`, { isActive }),
  enrich: (id) => apiClient.post(`${base}/${id}/enrich`, undefined, { timeout: 180000 }),
  refetchBody: (id) => apiClient.post(`${base}/${id}/refetch-body`, undefined, { timeout: 180000 }),
  translate: (id) => apiClient.post(`${base}/${id}/translate`, undefined, { timeout: 180000 }),
  updateMcqs: (id, mcqs) => apiClient.put(`${base}/${id}/mcqs`, { mcqs }),
  remove: (id) => apiClient.delete(`${base}/${id}`),
  bulk: (ids, action, payload = {}) => apiClient.post(`${base}/bulk`, { ids, action, payload }),
};

export default newsService;
